/**
 * Cart behavior is now simplified - cart icon always goes to cart page
 * Drawer auto-opens on add to cart via the auto-open attribute
 */
console.log('Cart behavior: Cart icon links to cart page, drawer auto-opens on add to cart');